import { api, ApiError } from '../api/client'
import type { Draft, DraftSheet } from '../api/types'
import { appendChamberBatch } from './chamber'
import { trimGrid } from './grid'

/** 出库之前先看第 1 页还够不够。不够就不要先标已售。 */
export async function firstSheetFitError(domains: string[]): Promise<string | null> {
  const draft = await api.get<Draft>('/api/draft')
  return appendChamberBatch(draft.sheets?.[0]?.cells ?? [], domains).error ?? null
}

/** 读草稿第 1 页，追加这一批，写回。版本被别人抢先改过就重读一次再追加，不覆盖对方的格子。 */
export async function parkBatchOnFirstSheet(domains: string[]): Promise<void> {
  let retried = false
  for (;;) {
    const draft = await api.get<Draft>('/api/draft')
    const sheets: DraftSheet[] = draft.sheets?.length
      ? draft.sheets.map((s) => ({ name: s.name, cells: (s.cells ?? []).map((row) => row.slice()) }))
      : [{ name: 'Sheet1', cells: [] }]
    const planned = appendChamberBatch(sheets[0].cells ?? [], domains)
    if (planned.error) throw new Error(planned.error)
    sheets[0] = { ...sheets[0], cells: trimGrid(planned.cells) }
    try {
      await api.post<Draft>('/api/draft', { sheets, version: draft.version })
      return
    } catch (e) {
      if (e instanceof ApiError && e.code === 'DRAFT_STALE' && !retried) {
        retried = true
        continue
      }
      throw e
    }
  }
}
